import styled from 'styled-components'
import { Spacing, Colors, Typography } from 'cio-design-library/design-tokens'
import { Media } from 'builder/styles/media'

export const Image = styled.img`
  width: 100%;
  max-width: 544px;

  ${Media.Phone`
    max-width: 354;
  `}
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${Spacing.M};
  max-width: 432px;
  margin-top: 41px;
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: ${Colors.Neutral80};
  text-align: center;
`

export const Title = styled.div`
  ${Typography.sizes.M};
`

export const Description = styled.div`
  ${Typography.sizes.Body};
`
